import React from 'react';
import { CloudRainIcon, TreePineIcon } from 'lucide-react';
import { TopoLines } from './TopoLines';
const blocks = [{
  time: '5 min',
  name: 'Hook',
  body: 'An opener that grabs the room the second kids walk in — with the exact words to say.',
  dot: 'bg-moss'
}, {
  time: '15–20 min',
  name: 'Skill Station',
  body: 'The skill explained to you first, in plain words, then taught step by step with short cues.',
  dot: 'bg-sky'
}, {
  time: '15–20 min',
  name: 'Patrol Challenge',
  body: 'A team challenge with exact rules, distances, timing and scoring. No guesswork.',
  dot: 'bg-ember'
}, {
  time: '10 min',
  name: 'Active Game',
  body: 'A game tied to the skill so they burn energy and practice without noticing.',
  dot: 'bg-patrol-mustard'
}, {
  time: '5 min',
  name: 'Campfire Close',
  body: 'A short close that wraps the night — script included — so they leave wanting next week.',
  dot: 'bg-patrol-teal'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="topo-dark relative w-full overflow-hidden border-y-4 border-ember bg-forest" data-id="element-209" data-mp="1b0p9l0vwynvg">
      <TopoLines className="pointer-events-none absolute -left-20 bottom-0 h-72 w-72 text-paper/[0.06]" data-id="element-210" data-mp="1jszj0fyzipbn" />
      <div className="relative mx-auto max-w-5xl px-5 py-14 sm:py-20" data-id="element-211" data-mp="1osm0j1luirq9">
        <div className="text-center" data-id="element-212" data-mp="s2cxb69pgxvn">
          <p className="eyebrow text-ember" data-id="element-213" data-mp="s3elmcfqfgvb">The mechanism</p>
          <h2 id="mechanism-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-paper sm:text-5xl" data-id="element-214" data-mp="w3ey3rj9thzq">
            The Grab-and-Lead Meeting Formula
          </h2>
          <p className="field-note mt-5 text-[28px] leading-tight text-paper sm:text-3xl" data-id="element-215" data-mp="162w284ivjntl">
            Grab the card. Read it once. Lead the meeting.
          </p>
          <p className="mx-auto mt-3 max-w-2xl text-base text-paper/80 sm:text-lg" data-id="element-216" data-mp="2hh1ctgdlevxw">
            Every one of the 60 meetings runs on the same five blocks, so after
            two weeks you can lead it from memory. It fills 45, 60 or 90 minutes
            — and it’s the whole meeting, not an idea you still have to build.
          </p>
        </div>

        {/* Trail de 5 bloques */}
        <ol className="relative mx-auto mt-9 max-w-2xl" data-id="element-217" data-mp="21opfoivuu39t">
          <span aria-hidden="true" className="absolute bottom-6 left-[19px] top-6 border-l-2 border-dashed border-paper/25" data-id="element-218" data-mp="1wta3rwheqhg1" />
          {blocks.map((block, i) => <li key={block.name} className="relative flex gap-4 pb-4 last:pb-0" data-id="element-219" data-mp="144mb3fubwpsg" data-mpi={i}>
              <span className={`relative z-10 flex h-10 w-10 flex-none items-center justify-center rounded-full font-display text-sm text-pine ring-4 ring-forest ${block.dot}`} data-id="element-220" data-mp="1it942kcvpg25">
                {i + 1}
              </span>
              <div className="flex-1 rounded-xl border border-paper/10 bg-paper/[0.06] px-4 py-3" data-id="element-221" data-mp="q9k1ahmd2gad">
                <div className="flex flex-wrap items-baseline justify-between gap-x-3" data-id="element-222" data-mp="laz8325j0wvf">
                  <span className="font-display text-lg text-paper" data-id="element-223" data-mp="2wy2hdnc3mfak">
                    {block.name}
                  </span>
                  <span className="text-[11px] font-bold uppercase tracking-widest text-ember" data-id="element-224" data-mp="2n2994g5ex7yl">
                    {block.time}
                  </span>
                </div>
                <p className="mt-1 text-sm leading-snug text-paper/80" data-id="element-225" data-mp="2rypux3p53a8i">
                  {block.body}
                </p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-6 grid max-w-2xl gap-3 sm:grid-cols-2" data-id="element-226" data-mp="3koyf1138k4pq">
          <div className="rounded-xl bg-moss-soft px-4 py-4 text-pine" data-id="element-227" data-mp="36p6usim4ls3a">
            <span className="flex items-center gap-2 font-display text-base" data-id="element-228" data-mp="3ar0rkft7aby6">
              <TreePineIcon className="h-5 w-5 text-moss-deep" aria-hidden="true" data-id="element-229" data-mp="1vatd5vhyu8vp" />
              The Age Dial
            </span>
            <p className="mt-1.5 text-sm leading-snug text-pine-soft" data-id="element-230" data-mp="1zcn8do9e6koh">
              Every meeting at three levels — ages 6–10, 11–14 and 15–17 — so
              mixed groups and older kids all get a real challenge.
            </p>
          </div>
          <div className="rounded-xl bg-sky-soft px-4 py-4 text-pine" data-id="element-231" data-mp="2aqqawi48rvf6">
            <span className="flex items-center gap-2 font-display text-base" data-id="element-232" data-mp="25ui0tj4wisev">
              <CloudRainIcon className="h-5 w-5 text-sky" aria-hidden="true" data-id="element-233" data-mp="20veuzwh3ki5u" />
              The Rain Swap
            </span>
            <p className="mt-1.5 text-sm leading-snug text-pine-soft" data-id="element-234" data-mp="2yhvosrqmgdmu">
              Every outdoor block has an indoor twin. Rain, cold or a small
              hall never cancels the plan again.
            </p>
          </div>
        </div>
      </div>
    </section>;
}